import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-report\"><defs><style type=\"text/css\"></style></defs><path d=\"M272 979.2H65.6c-12.8 0-24-11.2-24-24V595.2c0-12.8 11.2-24 24-24H272c12.8 0 24 11.2 24 24v360c0 12.8-11.2 24-24 24zM614.4 974.4H401.6c-12.8 0-24-11.2-24-24V59.2c0-12.8 11.2-24 24-24h212.8c12.8 0 24 11.2 24 24v891.2c0 12.8-11.2 24-24 24zM958.4 974.4H756.8c-12.8 0-24-11.2-24-24V371.2c0-12.8 11.2-24 24-24H960c12.8 0 24 11.2 24 24v579.2c-1.6 12.8-12.8 24-25.6 24z\" p-id=\"2142\" fill=\"#dbdbdb\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/report.svg
// module id = 2nwU
// module chunks = 132